export default __webpack_public_path__ + "static/media/605cff2fe67857e509e8a1db759b9602.png";